import React from 'react'
import { trackBuyMoreClick } from "../utils/ga4Events";
import api from '../config/api';

function BuyMore({ onClose }) {
  const handleBuyMoreClick = (platform) => {
    // GA Event
    trackBuyMoreClick({
      platform,
    });

    // Custom Analytics
    api.post("/interaction/track", {
      action: "BUY_MORE_CLICK",
      value: {
        platform,
      },
    });
  };
  return (
    <div className="scan-popup stay-tuned-popup">
      {/* Rays Background */}
      <img src="assets/images/rays.webp" className="popup-rays" alt="Rays" />
      <div className="popup-card">
        {/* Star */}
        <img
          src="assets/images/star-element.webp"
          className="popup-star"
          alt="Sparkle Element"
        />
        {/* Content */}
        <div className="popup-inner">
          <button className="howtp-close-btn" onClick={onClose} data-close-popup=".scan-popup">
            <img src="assets/images/close-icon.webp" alt="Close" />
          </button>
          <div className="stay-tuned-btns">
            <a href="https://www.bigbasket.com/pd/40023490/britannia-milk-bikis-biscuits-405-g/?utm_source=bigbasket&utm_medium=share_product&utm_campaign=share_product" target='_blank' className="stay-tuned-btn" onClick={() => trackBuyMoreClick('BigBasket')}>
              <img
                src="assets/images/bb-logo.png"
                alt="Big Basket"
                className="img-fit bb-logo"
              />
            </a>
            <a href="https://www.swiggy.com/stores/instamart/collection-listing?collectionId=284968&custom_back=true" target='_blank' className="stay-tuned-btn" onClick={() => trackBuyMoreClick('Swiggy')}>
              <img
                src="assets/images/instamart-logo.png"
                alt="Instamart"
                className="img-fit instamart-logo"
              />
            </a>
            <a href="https://blinkit.com/dc/?collection_uuid=679c5981-c52f-4389-a7b0-52815f85dfc8" className="stay-tuned-btn" target='_blank' onClick={() => trackBuyMoreClick('Blinkit')}>
              <img
                src="assets/images/blinkit-logo.png"
                alt="Blinkit"
                className="img-fit blinkit-logo"
              />
            </a>
          </div>
        </div>
      </div>
    </div>
  )
}

export default BuyMore
